<template>
  <p
    class="body mb-2 mt-2 fw-bold d-flex align-items-center"
    style="color: #fe6100; cursor: pointer"
    @click="openTravellerPanel"
  >
    <AttentionIcon />
    {{ t('reservations.missingTravellerInfoWarning') }}
  </p>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n'
  import AttentionIcon from '@/assets/AttentionIcon.vue'
  import { useStore } from '@/store'
  import { ModalId } from '@/config/modalIds'

  const { t } = useI18n()
  const store = useStore()

  const props = defineProps({
    booking: {
      type: Object,
      required: true,
    },
  })

  const openTravellerPanel = () => {
    store.dispatch('booking/selectBooking', props.booking)
    store.commit('modal/open', ModalId.TRAVELLER_PANEL)
    store.commit('modal/open', ModalId.BOOKING_PANEL)
  }
</script>
